import React from "react";

function TextSection() {
  return (
    <div className="text-container">
      <h3 className="heading text-dark">
        Shift the overall look and feel by adding these wonderful touches to
        furniture in your home
      </h3>
      <p className="paragraph text-light">
        Ever been in a room and felt like something was missing? Perhaps it felt
        slightly bare and uninviting. I’ve got some simple tips to help you make
        any room feel complete.
      </p>
    </div>
  );
}

export default TextSection;
